"use client"

import { create } from "zustand"

type WorkspaceInvitationAwarenessState = {
  promptsSuppressed: boolean
  suppressPrompts: () => void
  resetPrompts: () => void
}

export const useWorkspaceInvitationAwarenessStore = create<WorkspaceInvitationAwarenessState>()(
  (set) => ({
    promptsSuppressed: false,
    suppressPrompts: () => set({ promptsSuppressed: true }),
    resetPrompts: () => set({ promptsSuppressed: false }),
  }),
)
